type ProcStatus = 'NEW' | 'PARTIAL' | 'IN_PROGRESS' | 'READY'

export const PROC_STATUS_LABELS: Record<ProcStatus, string> = {
  NEW: 'Новая',
  PARTIAL: 'Частично',
  IN_PROGRESS: 'В работе',
  READY: 'Проквотирована',
}

const PROC_STATUS_CLASSES: Record<ProcStatus, string> = {
  NEW: 'bg-blue-100 text-blue-700',
  PARTIAL: 'bg-yellow-100 text-yellow-700',
  IN_PROGRESS: 'bg-orange-100 text-orange-700',
  READY: 'bg-green-100 text-green-700',
}

export function ProcStatusBadge({ status }: { status: ProcStatus }) {
  return (
    <span
      className={`inline-flex items-center px-2 py-0.5 rounded text-xs font-medium ${PROC_STATUS_CLASSES[status]}`}
    >
      {PROC_STATUS_LABELS[status]}
    </span>
  )
}
